/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async listAssetAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("asset/accounts/list", data);
    return response;
  },

  async listPaymentAccounts() {
    let data = { source: "Web" };
    let response = await apiCall("income/payment-accounts/list", data);
    return response;
  },

  async addAsset(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("asset/add", data);
    return response;
  },

  async getAssetBalance() {
    let data = { source: "Web" };
    let response = await apiCall("asset/balance", data);
    return response;
  },

  async listAssetBalances() {
    let data = { source: "Web" };
    let response = await apiCall("asset/balances/list", data);
    return response;
  },

  async addContra(data) {
    return await apiCall("asset/contra/add", data);
  },

  async fetchAccountsReceivable() {
    let data = { source: "Web" };
    let response = await apiCall("receivable/accounts/list", data);
    return response;
  },

  async appreciateValue(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("asset/value/appreciate", data);
    return response;
  },

  async depreciateValue(paymentAccount, targetAccount, amount, transactionDate, description, payee, transactionRef, tag) {
    let data = {
      trail_account: paymentAccount,
      target_account: targetAccount,
      amount: amount,
      transaction_date: transactionDate,
      description: description,
      payee: payee,
      transaction_reference: transactionRef,
      tag: tag,
    };
    let response = await apiCall("asset/value/depreciate", data);
    return response;
  },

  async fetchBankCash() {
    let response = await apiCall("transaction/asset/asset/bank_cash_balance", []);
    return response;
  },

  async fetchBankCashListing() {
    let response = await apiCall("transaction/asset/asset/list_cash_bank_balances", []);
    return response;
  },

  async postMultiContras(data){
    return await apiCall("transaction/asset/asset/do_multiple_contra", data);
  }

  
};
